// couponApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface Coupon {
  id: number;
  code: string;
  discount_type: string;
  discount_value: number | string;
  min_amount: number | string;
  max_discount: number | string;
  start_date: string;
  end_date: string;
  status?: string;
  usage_limit?: number;
  used_count?: number;
  created_at?: string;
}

export interface CouponFormData {
  code: string;
  discount_type: 'flat' | 'percentage';
  discount_value: number | string;
  min_amount: number | string;
  max_discount: number | string;
  start_date: string;
  end_date: string;
  usage_limit?: number;
}

export const couponApi = createApi({
  reducerPath: 'couponApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://fftestservice.sarsetech.com/',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey',
        '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Coupon'],
  endpoints: (build) => ({
    listCoupons: build.query<{ data: Coupon[]; error: boolean; message: string }, void>({
      query: () => ({
        url: 'user/couponslist',
        method: 'POST',
        body: {},
      }),
      providesTags: ['Coupon'],
    }),
    createCoupon: build.mutation<any, CouponFormData>({
      query: (couponData) => ({
        url: 'user/couponscreate',
        method: 'POST',
        body: couponData,
      }),
      invalidatesTags: ['Coupon'],
    }),
    updateCoupon: build.mutation<any, { id: number } & Partial<CouponFormData>>({
      query: ({ id, ...couponData }) => ({
        url: 'user/couponsupdate',
        method: 'POST',
        body: {
          id,
          ...couponData,
        },
      }),
      invalidatesTags: ['Coupon'],
    }),
    deleteCoupon: build.mutation<any, number>({
      query: (id) => ({
        url: 'user/couponsdelete',
        method: 'POST',
        body: { id },
      }),
      invalidatesTags: ['Coupon'],
    }),
  }),
});

export const {
  useListCouponsQuery,
  useCreateCouponMutation,
  useUpdateCouponMutation,
  useDeleteCouponMutation,
} = couponApi;